export default function SignUpMobile() {
  return <h1>Sign up mobile</h1>;
}
